import React from "react"
import { graphql, Slice } from "gatsby"
import Layout from "../components/layout"
import WpStoryContentBlocks from "../components/content-blocks/WpStoryContentBlocks"
import TitleSection from '../components/parts/TitleSection/WordPressTitleSection'
import SocialShareLinks from '../components/parts/SocialShareLinks'
import FeaturedImage from "../components/content-blocks/FeaturedImage"
import AdviceComments from "../components/content-blocks/AdviceComments"
import BreadCrumbs from "../components/page-sections/BreadCrumbs"
import EmbedVideoFormatHandler from "../components/content-blocks/EmbedVideoFormatHandler"
import ContentWrapper from '../components/content-modules/ContentWrapper'

function NewsPost({ data }) {
  const { post } = data
  const { 
    id, 
    title, 
    featuredImage, 
    hideFeaturedImage, 
    categories, 
    products, 
    author, 
    postExternalAuthors, 
    month, 
    dayYear, 
    excerpt, 
    heroImage, 
    link, 
    linkFormat
  } = post
  const { nodes } = products
  const postProduct = nodes?.[0]

  /** if this is a "link" post, we should never even get here, but if we do, this renders 
   * a browser redirect
   */
  if (typeof window !== "undefined" && window.location && linkFormat?.linkUrl) {
    window.location.replace(linkFormat.linkUrl)
  }

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const date = `${months[parseInt(month)-1]} ${dayYear}`
  const product =  products?.nodes?.[0] || null
  const displayAuthor = postExternalAuthors?.nodes?.[0]?.name || author.node.name

  let heroSize = heroImage.heroImage && heroImage.heroImage.mediaDetails.width ? heroImage.heroImage.mediaDetails.width : null
  let featSize = featuredImage?.node?.mediaDetails.width 
  let size = featSize > heroSize ? featSize : heroSize

  const isVideo = post?.videoFormat?.vimeoId

  const isAlt = (
    post?.acfAlternatePostType?.alternateposttype === 'poll' || 
    post?.acfAlternatePostType?.alternateposttype === 'quiz' || 
    post?.acfAlternatePostType?.alternateposttype === 'scrapbook' || 
    post?.acfAlternatePostType?.alternateposttype === 'podcast' 
  ) 
  
  let image = null
  if ((size >= 1080) && featuredImage?.node?.localFile?.childImageSharp){
    image = featuredImage?.node
  } else if ((718 <= size && size < 1080) && heroImage?.heroImage?.localFile?.childImageSharp){
    image = heroImage.heroImage
  } else if ((718 <= size && size < 1080) && featuredImage?.node?.localFile?.childImageSharp){
    image = featuredImage.node
  } else if((size < 718) && featuredImage){
    image = featuredImage.node
  }
  /* TODO: refactor this so that TitleSection is only written out once, by running this check on the 
   props that have different values instead of on the whole component */
  const postHeader =
  isVideo || isAlt ? (
    <TitleSection
      heading={title}
      author={displayAuthor}
      product={product}
      categories={categories}
      date={date}
      size={size}
      shareURL={`/news${link}`}
    />
  ) : (
    <TitleSection
      heading={title}
      author={displayAuthor}
      product={product}
      categories={categories}
      date={date}
      excerpt={excerpt}
      smImg={718 > size ? image : null}
      size={size}
      shareURL={`/news${link}`}
    />
  )
  let productParent = postProduct?.pages?.nodes?.[0] || null
  
  let links = (productParent?.uri) 
    ? [
    { url: "/", name: "Home" },
    { url: "/news", name: "News & Stories" },
    { url: productParent.uri, name: product.name },
    { url: link, name: title },
    ]
    : [
      { url: "/", name: "Home" },
      { url: "/news", name: "News & Stories" },
      { url: link, name: title },
    ]

  return (
    <Layout title={title} url={`/news${link}`} img={image}>
      <ContentWrapper>
        <BreadCrumbs links={links} />
        {postHeader}
        {image && !hideFeaturedImage?.hideFeaturedImage && size >= 718 && !isVideo && !isAlt && (
          <FeaturedImage featuredImage={image} size={size}/>
        )}
        {isVideo && (
          <EmbedVideoFormatHandler source={isVideo} />
        )}
        <WpStoryContentBlocks {...post} /><div></div>
        <SocialShareLinks
          text="Share This Story"
          title={title}
          excerpt={excerpt}
          url={`/news${link}`}
          center
          gtmLocation="bottom"
        />
        </ContentWrapper>
        <Slice alias="related-posts" postId={id} postProduct={postProduct} allowEmpty />
      
    </Layout>
  )
}

export default NewsPost



export const query = graphql`
  query post($id: String!) {
    post: wpPost(id: { eq: $id }) {
      id
      title
      content
      linkFormat {
        linkAuthor
        linkUrl
      }
      blocks {
        name
        order
        isDynamic
        originalContent
        dynamicContent
        saveContent
        innerBlocks {
          order
          name
          order
          isDynamic
          originalContent
          dynamicContent
          ... on WpCoreImageBlock {
            mediaItem {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
          innerBlocks {
            order
            name
            order
            isDynamic
            saveContent
            dynamicContent
            originalContent
          }
        }
      }
      uri
      link
      dayYear: date(formatString: "DD, YYYY")
      month: date(formatString: "MM")
      excerpt
      author {
        node {
          firstName
          lastName
          name
        }
      }
      featuredImage {
        node {
          altText
          caption
          description
          mediaDetails {
            height
            width
          }
          localFile {
            ...HeroImageNew
          }
        }
      }
      hideFeaturedImage {
        hideFeaturedImage
      }
      heroImage {
        heroImage {
          altText
          caption
          mediaDetails {
            height
            width
          }
          author{
            node{
              name
            }
          }
          localFile{
            ...HeroImageNew
          }
        }
      }
      categories {
        nodes {
          id
          name
          slug
        }
      }
      products {
        nodes {
          id
          name
          slug
          pages {
            nodes {
              uri
            }
          }
        }
      }
      acfAlternatePostType{
        alternateposttype
      }
      videoFormat {
        vimeoId
      }
      linkFormat {
        linkAuthor
        linkUrl
      }
      postExternalAuthors {
        nodes {
          name
          slug
        }
      }

    }
  }
`
